import store from "../redux/Store";
import {safeLocalStorage} from "./storage";

const baseUrl = `https://${process.env.REACT_APP_API_URL}/`;

const ApiConnect = function (config) {
  const { method = 'GET', url, data } = config;

  const state = store.getState();
  const token = state.Auth?.Token || safeLocalStorage.getItem("Token");
  const userData = state.Auth?.userData || {};

  const headers = {
    'Authorization': process.env.REACT_APP_API_KEY,
    'Company': process.env.REACT_APP_COMPANY,
    'Theme': process.env.REACT_APP_THEME,
  };

  if (token) headers['Token'] = token;
  if (userData?.user_id) headers['UserID'] = userData.user_id;

  const fullUrl = baseUrl + url;

  return fetch(fullUrl, {
    method,
    headers,
    body: data && method !== 'GET' ? data : undefined,
  })
    .then(async (response) => {
      let responseData;
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        responseData = await response.json();
      } else {
        responseData = await response.text();
      }

      if (!response.ok) {
        if (response.status === 401) {
          try {
            const { LogoutUser } = await import("../redux/actions/Auth.Action");
            store.dispatch(LogoutUser());
          } catch (e) {}
        }
        throw { response: { status: response.status, data: responseData } };
      }

      return { data: responseData };
    })
    .catch((error) => {
      if (error.response) {
        throw error;
      }
      throw { response: { status: 500, data: error.message } };
    });
};

ApiConnect.get = function (url, config = {}) {
  return ApiConnect({ method: 'GET', url, ...config });
};

ApiConnect.post = function (url, data, config = {}) {
  return ApiConnect({ method: 'POST', url, data, ...config });
};

ApiConnect.put = function (url, data, config = {}) {
  return ApiConnect({ method: 'PUT', url, data, ...config });
};

ApiConnect.delete = function (url, config = {}) {
  return ApiConnect({ method: 'DELETE', url, ...config });
};

export default ApiConnect;